import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exams-course-section-edit',
  templateUrl: './exams-course-section-edit.component.html',
  styleUrls: ['./exams-course-section-edit.component.css']
})
export class ExamsCourseSectionEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
